export default "/assets/Icon/Pause.svg"